import type { MinifiedTask, TaskInternalExternal } from '@gcv/shared';

import { getTaskDirection } from './get-task-direction';

interface TaskListFilters {
  taskDirection: TaskInternalExternal;
  startDate: string;
  endDate: string;
}

/**
 * Whether a task belongs in a bank task list loaded with the given filters. The list endpoint
 * splits the tabs by whether a task is assigned outside the bank that owns it, and ranges on the
 * creation date rather than the due date.
 */
export const isTaskInTaskList = (task: MinifiedTask, filters: TaskListFilters): boolean => {
  if (getTaskDirection(task) !== filters.taskDirection) return false;

  const dateCreated = new Date(task.date_created).getTime();

  return (
    dateCreated >= new Date(filters.startDate).getTime() && dateCreated <= new Date(filters.endDate).getTime()
  );
};
